import * as React from "react";
import { connect } from "react-redux";
import { Col, Row, Button } from "reactstrap";
import { momentToString, timestampToMoment } from "src/share/utils/utils";
import { IReduxState } from "src/reduxTypes";
import ConfirmationModal from "src/share/components/ConfirmationModal/ConfirmationModal";
import { UserTypes } from "src/modules/Auth/store/types";
import { IWebiqMatchCardProps, IMatchCardState } from "./types";
import xmark from "src/images/xmark-solid.svg";

export class WebiqMatchCard extends React.Component<
  IWebiqMatchCardProps,
  IMatchCardState
> {
  constructor(props: IWebiqMatchCardProps) {
    super(props);
    this.state = {
      showDelete: false,
    };
  }
  public modalToggle = (): void => {
    this.setState({ showDelete: !this.state.showDelete });
  };
  public isAdmin() {
    return this.props.auth.userType === UserTypes.ADMIN;
  }

  public render(): JSX.Element {
    const { createdAt, href, caseId, childId, url, matchId, childInfo } =
      this.props.matchData;

    return (
      <Col xl="4" lg="6" md="12" sm="12" xs="12">
        <div className="info-card white-background">
          <Row>
            <Col md="3" sm="3" xs="3" className="images-column">
              <div className="image-background">
                <img src={url} alt="Face" />
              </div>
              <p>
                <i className="fa fa-exchange fa-rotate-90" />
              </p>
              <div className="image-background">
                <img
                  src={`${process.env.REACT_APP_HOST}/api/webiq/image?url=${href}`}
                  alt="Face"
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = xmark;
                  }}
                />
              </div>
            </Col>
            <Col md="9" sm="9" xs="9">
              <Row>
                <div className="child-name">
                  <h4>{childInfo.fullName || "Unknown"}</h4>
                </div>
              </Row>
              <Row>
                <div className="match-data">
                  <p>
                    <label>Case ID:</label>
                    <span className="subFont">{caseId || "Unknown"}</span>
                  </p>
                  <p>
                    <label>ChildId:</label>
                    <span className="subFont">{childId || "Unknown"}</span>
                  </p>
                  <div className="date">
                    <p>
                      <label>Created at:</label>
                      <span className="subFont">
                        {createdAt
                          ? momentToString(timestampToMoment(createdAt))
                          : "Unknown"}
                      </span>
                    </p>
                  </div>
                  <p>
                    <label>Source:</label>
                    <span className="subFont">{href || "Unknown"}</span>
                  </p>
                </div>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col className="text-right" md="12" sm="12" xs="12">
              {this.isAdmin() && (
                <Button className="btn-blue" onClick={() => this.modalToggle()}>
                  Discard
                </Button>
              )}
              <Button
                className="btn-blue"
                onClick={() =>
                  this.props.history.push(
                    `/rekognition/matches/webiq/${caseId}/${childId}/${matchId}`
                  )
                }
              >
                View
              </Button>
            </Col>
          </Row>
        </div>
        <ConfirmationModal
          isOpen={this.state.showDelete}
          toggle={() => {
            this.modalToggle();
          }}
          title={"Discard Match"}
          description={
            this.props.deleting
              ? "Discarding match..."
              : "Are you sure you want to discard this match"
          }
          onContinue={this.props.deleteMatch(matchId)}
          loading={this.props.deleting}
          showButtons={!this.props.deleting}
        />
      </Col>
    );
  }
}
const mapStateToProps = (state: IReduxState) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(WebiqMatchCard);



// WEBPACK FOOTER //
// ./src/modules/AdHocTools/Webiq/WebiqMatchCard.tsx